<template>
	<div class="flex items-center justify-between w-full ms-pagination">
		<div class="postion-pagination flex">
			<span v-if="!hidePageRange">
				{{ $t('i18nComponent.TotalItem') }}
				<strong>{{ pageTotal }}</strong>
			</span>
			<div class="flex ml-8" v-if="pagingTemplate">
				<component
					:is="pagingTemplate.template"
					:data="data"
					v-bind="pagingTemplate.props"
				></component>
			</div>
		</div>

		<div class="flex left-pagination align-center">
			<div class="mr-5 flex items-center">
				<div
					v-if="!hidePageRange"
					@click="firstPage"
					:class="{ disableText: disablePrevPage }"
					class="mr-4 cursor-pointer unselect flex items-center"
				>
					<div class="mi mi-18 mi-pre-page"></div>
					{{ $t('i18nComponent.First') }}
				</div>
				<div
					@click="previousPage"
					:class="{ disableText: disablePrevPage }"
					class="mr-4 cursor-pointer unselect"
				>
					{{ $t('i18nComponent.Previous') }}
				</div>
				<strong v-if="!hidePageRange">
					{{
						`${dataRender == 0 ? 0 : (pageIndex - 1) * pageSize + 1}-${
							(pageIndex - 1) * pageSize + dataRender
						}`
					}}
					<span class="disableText">{{ $t('i18nComponent.Of') }}</span>
					{{ `${pageTotal}` }}
				</strong>
				<div
					@click="nextPage"
					:class="{ disableText: disableNextPage }"
					class="ml-4 cursor-pointer unselect"
				>
					{{ $t('i18nComponent.Next') }}
				</div>

				<div
					v-if="!hidePageRange"
					@click="lastPage"
					:class="{ disableText: disableNextPage }"
					class="ml-4 cursor-pointer unselect flex items-center"
				>
					{{ $t('i18nComponent.Latest') }}
					<div class="mi mi-18 mi-next-page"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import MSStore from '@/store/msstore';
export default {
	name: 'msPagination',
	props: {
		pageSize: {
			default: 0,
			type: [Number, String],
		},
		dataRender: {
			default: 0,
			type: [Number, String],
		},
		/**
		 * Tổng số bản ghi của dữ liệu
		 */
		pageTotal: {
			default: 0,
			type: [Number, String],
		},
		pageIndex: {
			default: 1,
			type: Number,
		},
		pagingTemplate: {},
		data: {},
		/**
		 * Ẩn range số bản ghi (1-N of Total) và nút First/Last, chỉ giữ nút Previous/Next
		 */
		hidePageRange: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		//Kiểm tra hiện thị ... đầu tiên
		//Created by LTDAT (01/04/2020)

		checkFirstDotted() {
			let me = this,
				listFirst = [1, 2];
			return (
				this.totalPages > 4 &&
				listFirst.indexOf(this.viewPage) < 0 &&
				this.viewPage > 2
			);
		},
		//Kiểm tra hiện thị dấu ... thứ 2
		//Created by LTDAT (01/04/2020)

		checkSecondDotted() {
			return this.totalPages > 4 && this.viewPage <= this.totalPages - 3;
		},
		/**
		 * index của bản ghi cuối cùng trong trang trên tập dữ liệu trong DB
		 */
		toNumberRecord() {
			return (this.pageIndex - 1) * this.pageSize + this.dataRender;
		},

		/**
		 * Tổng số trang theo pageSize hiện tại của grid
		 */
		totalPages() {
			return Math.ceil(this.pageTotal / this.pageSize);
		},

		disableNextPage() {	
			if (this.hidePageRange && this.dataRender < this.pageSize){
				return true;
			}

			if (!this.hidePageRange && this.pageIndex >= this.totalPages && !this.useServerSide) {
				return true;
			}
			return false;
		},
		disablePrevPage() {
			if (this.pageIndex <= 1) {
				return true;
			}
			return false;
		},
	},
	data() {
		let me = this,
			grd = me.$parent,
			store = grd.store;
		return {
			viewPage: this.pageIndex,
			modeRecordInPage: 20,
			currentPage: this.pageIndex,
			recordInPageStore: new MSStore({
				data: [
					{
						recordInPageValue: 20,
						recordInPageDisplay: '20',
					},
					{
						recordInPageValue: 30,
						recordInPageDisplay: '30',
					},
					{
						recordInPageValue: 50,
						recordInPageDisplay: '50',
					},
					{
						recordInPageValue: 100,
						recordInPageDisplay: '100',
					},
				],
			}),
		};
	},
	mounted() {},
	methods: {
		//Load lại page theo số trang.
		loadPageIndex(index) {
			const me = this;
			let payload = {
				Skip: (index - 1) * me.pageSize,
				Take: me.pageSize,
			};
			me.$emit('loadData', payload);
		},
		nextPage() {
			const me = this;
			if (!me.disableNextPage) {
				me.loadPageIndex(this.pageIndex + 1);
			}
		},

		firstPage() {
			const me = this;
			if (!me.disablePrevPage) {
				me.loadPageIndex(1);
			}

			// this.$parent.store.loadPage(1);
		},

		lastPage() {
			const me = this;
			if (!me.disableNextPage) {
				me.loadPageIndex(me.totalPages);
			}

			// this.$parent.store.loadPage(this.pageIndex);
		},

		previousPage() {
			const me = this;
			if (!me.disablePrevPage) {
				me.loadPageIndex(this.pageIndex - 1);
			}
		},
	},
	watch: {
		pageSize(newValue, oldValue) {
			this.modeRecordInPage = newValue;
		},
	},
};
</script>
<style scoped lang='scss'>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
</style>

